// @flow
import React from "react";
import Modal, { ModalSize } from "components/Modal";
import Button from "react-bootstrap/lib/Button";
import { createModal } from "react-modal-promise";
// import styles from "./ConfirmModal.module.css";
import "font-awesome/css/font-awesome.css";
import FontAwesome from "react-fontawesome";
import loc from "i18next";
// import { LoadingType } from "data/types";
// import Loader from "components/Loader";
import "./index.css";
import QrReader from "react-qr-reader";

// /* istanbul ignore next */
// const QrReader = Loader(
//     {
//         loader: () =>
//             import(
//                 "react-qr-reader" /* webpackChunkName: "component-QrReader" */
//             )
//     },
//     LoadingType.Status
// );

type Props = {
    /** react-modal-promise: whether to show dialog */
    open: boolean,
    /** react-modal-promise: callback when user closes Dialog
     * @param {string} barcode returns the parsed barcode or undefined if user cancelled
     */
    close: (barcode?: string) => void,
    /** Modal Dialog title */
    title?: string,
};

type State = {
    result: ?string,
    legacy: boolean,
};

/** presents a Barcode dialog to the user
 * @returns {string} barcode found, null/undefined otherwise
 */
export class BarcodeModal extends React.PureComponent<Props, State> {
    bc: null | QrReader;

    state = {
        result: null,
        legacy: true,
    };

    constructor(props: Props) {
        super(props);
        this.state = {
            legacy: !(
                "mediaDevices" in navigator &&
                "getUserMedia" in navigator.mediaDevices
            ),
        };
        this._onError = this._onError.bind(this);
    }

    _onScan = (result: ?string) =>
        (result != null || this.state.legacy) && this.props.close(result);

    /* istanbul ignore next */ _onUpload = () => this.bc.openImageDialog();

    _onError = (err) => {
        if (err && err.name === "NotFoundError") {
            this.setState({ legacy: true });
        } else console.error("Barcode error: ", err);
    };

    render() {
        const { open, close, title } = this.props;
        return (
            <Modal
                dialogClassName="barcode-modal"
                size={ModalSize.Small}
                enforceFocus
                show={open !== false}
                onHide={/* istanbul ignore next */ () => close(false)}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <FontAwesome name="barcode" /> {title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <QrReader
                        ref={/*istanbul ignore next*/ (ref) => (this.bc = ref)}
                        delay={300}
                        onError={this._onError}
                        onScan={this._onScan}
                        style={{ height: "100%" }}
                        legacyMode={this.state.legacy}
                    />
                    {this.state.legacy && (
                        <p style={{ textAlign: "center", color: "red" }}>
                            {loc.t("barcode:noCamera")}
                        </p>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    {this.state.legacy && (
                        <Button bsStyle="primary" onClick={this._onUpload}>
                            {loc.t("barcode:uploadButton")}
                        </Button>
                    )}
                    {this.state.legacy === false && (
                        <Button
                            bsStyle="link"
                            disabled={!this.state.result}
                            onClick={
                                /* istanbul ignore next */ () =>
                                    close(this.state.result)
                            }
                        >
                            <FontAwesome name="spinner" pulse />
                        </Button>
                    )}
                    <Button
                        onClick={/* istanbul ignore next */ () => close(false)}
                    >
                        {loc.t("cancel")}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}
export const openBarcodeModal = createModal(BarcodeModal);
